"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceStatusLabel = exports.patientServiceColor = exports.getGroupStatusProperty = void 0;
exports.stringAvatar = stringAvatar;
exports.getSocStarterValue = getSocStarterValue;
const domain_1 = require("@home-health-notify/domain");
const config_1 = require("../i18n/config");
const theme_1 = require("../theme");
const getGroupStatusProperty = (status, statusInk) => {
    const ink = statusInk !== null && statusInk !== void 0 ? statusInk : theme_1.HHNTheme.status;
    switch (status) {
        case 1: //NON_ADMIT
            return {
                upperBarColor: theme_1.HHNTheme.status.nonAdmit,
                lowerBarColor: theme_1.HHNTheme.status.nonAdmit,
                upperInkColor: ink.nonAdmit,
                lowerInkColor: ink.nonAdmit,
                title: config_1.resources.en.patientGroup.status.nonAdmit,
            };
        case 2: //PENDING_SOC
            return {
                upperBarColor: theme_1.HHNTheme.status.pendingSoc,
                lowerBarColor: theme_1.HHNTheme.status.pendingSoc,
                upperInkColor: ink.pendingSoc,
                lowerInkColor: ink.pendingSoc,
                title: config_1.resources.en.patientGroup.status.pendingSoc,
            };
        case 3: //ACTIVE
            return {
                upperBarColor: theme_1.HHNTheme.status.active,
                lowerBarColor: theme_1.HHNTheme.status.active,
                upperInkColor: ink.active,
                lowerInkColor: ink.active,
                title: config_1.resources.en.patientGroup.status.active,
            };
        case 4: //HOSPITALIZED
            return {
                upperBarColor: theme_1.HHNTheme.status.hospitalized,
                lowerBarColor: theme_1.HHNTheme.status.hospitalized,
                upperInkColor: ink.hospitalized,
                lowerInkColor: ink.hospitalized,
                title: config_1.resources.en.patientGroup.status.hospitalized,
            };
        case 5: //PENDING_ROC
            return {
                upperBarColor: theme_1.HHNTheme.status.hospitalized,
                lowerBarColor: theme_1.HHNTheme.status.pendingSoc,
                upperInkColor: ink.hospitalized,
                lowerInkColor: ink.pendingSoc,
                title: config_1.resources.en.patientGroup.status.pendingRoc,
            };
        case 6: //DISCHARGED
            return {
                upperBarColor: theme_1.HHNTheme.status.discharged,
                lowerBarColor: theme_1.HHNTheme.status.discharged,
                upperInkColor: ink.discharged,
                lowerInkColor: ink.discharged,
                title: config_1.resources.en.patientGroup.status.discharged,
            };
        default:
            return {
                upperBarColor: "#000000",
                lowerBarColor: "#000000",
                upperInkColor: "#000000",
                lowerInkColor: "#000000",
                title: config_1.resources.en.patientGroup.status.invalid,
            };
    }
};
exports.getGroupStatusProperty = getGroupStatusProperty;
const patientServiceColor = (status) => {
    switch (status) {
        case domain_1.SERVICE_STATUS.PENDING:
            return theme_1.HHNTheme.status.pendingSoc;
        case domain_1.SERVICE_STATUS.ACTIVE:
            return theme_1.HHNTheme.status.active;
        case domain_1.SERVICE_STATUS.DISCHARGED:
            return theme_1.HHNTheme.status.discharged;
        case domain_1.SERVICE_STATUS.END_OF_CARE:
            return theme_1.HHNTheme.status.endOfCare;
    }
};
exports.patientServiceColor = patientServiceColor;
function stringAvatar(name, onlyFirstNameInitial = false, maxInitials = 2) {
    const namesArray = name.trim().toUpperCase().split(/\s+/);
    // Helper function to get first alphanumeric character from a string
    const getFirstAlphanumeric = (str) => {
        const match = str.match(/[A-Z0-9]/);
        return match ? match[0] : "";
    };
    const firstInitial = getFirstAlphanumeric(namesArray[0]);
    if (!firstInitial)
        return "?"; // Fallback if no valid character found
    if (namesArray.length === 1 || onlyFirstNameInitial) {
        return firstInitial;
    }
    // Collect initials from each word up to maxInitials
    const initials = [firstInitial];
    for (let i = 1; i < namesArray.length && initials.length < maxInitials; i++) {
        const initial = getFirstAlphanumeric(namesArray[i]);
        if (initial) {
            initials.push(initial);
        }
    }
    return initials.join("");
}
function getSocStarterValue(role) {
    if (role) {
        if (role.SN)
            return domain_1.CLINICIAN_ROLES.SN;
        if (role.OT)
            return domain_1.CLINICIAN_ROLES.OT;
        if (role.SLP)
            return domain_1.CLINICIAN_ROLES.SLP;
        if (role.PT)
            return domain_1.CLINICIAN_ROLES.PT;
    }
    return domain_1.CLINICIAN_ROLES.SN;
}
exports.serviceStatusLabel = {
    [domain_1.SERVICE_STATUS.PENDING]: config_1.resources.en.common.serviceStatusLabel.pending,
    [domain_1.SERVICE_STATUS.DISCHARGED]: config_1.resources.en.common.serviceStatusLabel.discharged,
    [domain_1.SERVICE_STATUS.ACTIVE]: config_1.resources.en.common.serviceStatusLabel.active,
};
